import { render } from "./basicTabs.vue?vue&type=template&id=86971076"
import script from "./basicTabs.vue?vue&type=script&lang=js"
export * from "./basicTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__